/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CorporateStructureLink', 'model/IntegrationPipedriveSettingsPipelineReportPaginationSlice'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./CorporateStructureLink'), require('./IntegrationPipedriveSettingsPipelineReportPaginationSlice'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.IntegrationPipedriveSettingsReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.CorporateStructureLink, root.ForStractionServiceApi.IntegrationPipedriveSettingsPipelineReportPaginationSlice);
  }
}(this, function(ApiClient, CorporateStructureLink, IntegrationPipedriveSettingsPipelineReportPaginationSlice) {
  'use strict';




  /**
   * The IntegrationPipedriveSettingsReport model module.
   * @module model/IntegrationPipedriveSettingsReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>IntegrationPipedriveSettingsReport</code>.
   * @alias module:model/IntegrationPipedriveSettingsReport
   * @class
   */
  var exports = function() {
    var _this = this;

















  };

  /**
   * Constructs a <code>IntegrationPipedriveSettingsReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationPipedriveSettingsReport} obj Optional instance to populate.
   * @return {module:model/IntegrationPipedriveSettingsReport} The populated <code>IntegrationPipedriveSettingsReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Pipelines')) {
        obj['Pipelines'] = IntegrationPipedriveSettingsPipelineReportPaginationSlice.constructFromObject(data['Pipelines']);
      }
      if (data.hasOwnProperty('Added')) {
        obj['Added'] = ApiClient.convertToType(data['Added'], 'Date');
      }
      if (data.hasOwnProperty('AddedBy')) {
        obj['AddedBy'] = ApiClient.convertToType(data['AddedBy'], 'Integer');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('RootDomain')) {
        obj['RootDomain'] = ApiClient.convertToType(data['RootDomain'], 'String');
      }
      if (data.hasOwnProperty('APIKey')) {
        obj['APIKey'] = ApiClient.convertToType(data['APIKey'], 'String');
      }
      if (data.hasOwnProperty('ImportOpenDeals')) {
        obj['ImportOpenDeals'] = ApiClient.convertToType(data['ImportOpenDeals'], 'Boolean');
      }
      if (data.hasOwnProperty('ImportActivities')) {
        obj['ImportActivities'] = ApiClient.convertToType(data['ImportActivities'], 'Boolean');
      }
      if (data.hasOwnProperty('ImportActivitiesSyncUsers')) {
        obj['ImportActivitiesSyncUsers'] = ApiClient.convertToType(data['ImportActivitiesSyncUsers'], 'Boolean');
      }
      if (data.hasOwnProperty('ImportOpenDealsIndicatorID')) {
        obj['ImportOpenDealsIndicatorID'] = ApiClient.convertToType(data['ImportOpenDealsIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('ImportActivitiesIndicatorID')) {
        obj['ImportActivitiesIndicatorID'] = ApiClient.convertToType(data['ImportActivitiesIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('CorporateStructureLink')) {
        obj['CorporateStructureLink'] = CorporateStructureLink.constructFromObject(data['CorporateStructureLink']);
      }
      if (data.hasOwnProperty('LastSyncTime')) {
        obj['LastSyncTime'] = ApiClient.convertToType(data['LastSyncTime'], 'Date');
      }
      if (data.hasOwnProperty('IncludeForecast')) {
        obj['IncludeForecast'] = ApiClient.convertToType(data['IncludeForecast'], 'Boolean');
      }
      if (data.hasOwnProperty('ForecastIndicatorID')) {
        obj['ForecastIndicatorID'] = ApiClient.convertToType(data['ForecastIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {module:model/IntegrationPipedriveSettingsPipelineReportPaginationSlice} Pipelines
   */
  exports.prototype['Pipelines'] = undefined;
  /**
   * @member {Date} Added
   */
  exports.prototype['Added'] = undefined;
  /**
   * @member {Integer} AddedBy
   * @default 0
   */
  exports.prototype['AddedBy'] = 0;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {String} RootDomain
   * @default ''
   */
  exports.prototype['RootDomain'] = '';
  /**
   * @member {String} APIKey
   * @default ''
   */
  exports.prototype['APIKey'] = '';
  /**
   * @member {Boolean} ImportOpenDeals
   */
  exports.prototype['ImportOpenDeals'] = undefined;
  /**
   * @member {Boolean} ImportActivities
   */
  exports.prototype['ImportActivities'] = undefined;
  /**
   * @member {Boolean} ImportActivitiesSyncUsers
   */
  exports.prototype['ImportActivitiesSyncUsers'] = undefined;
  /**
   * @member {Integer} ImportOpenDealsIndicatorID
   */
  exports.prototype['ImportOpenDealsIndicatorID'] = undefined;
  /**
   * @member {Integer} ImportActivitiesIndicatorID
   */
  exports.prototype['ImportActivitiesIndicatorID'] = undefined;
  /**
   * @member {module:model/CorporateStructureLink} CorporateStructureLink
   */
  exports.prototype['CorporateStructureLink'] = undefined;
  /**
   * @member {Date} LastSyncTime
   */
  exports.prototype['LastSyncTime'] = undefined;
  /**
   * @member {Boolean} IncludeForecast
   */
  exports.prototype['IncludeForecast'] = undefined;
  /**
   * @member {Integer} ForecastIndicatorID
   */
  exports.prototype['ForecastIndicatorID'] = undefined;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


